import { DateRange } from 'react-day-picker';
import format from 'date-fns/format';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';

import { DATE_FORMAT, ISO_DATE_FORMAT } from './date-picker.constants';

const DATE_INPUT_FORMAT_REGEX = /^(\d{1,2})[./-](\d{1,2})[./-](\d{4})/;

export function toDateFromDatePickerFormat(date: string) {
  const match = date.match(DATE_INPUT_FORMAT_REGEX);
  if (match) {
    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    return new Date(parseInt(match[3], 10), month - 1, day);
  }
}

export function toDatePickerFormat(date: string | Date) {
  return format(typeof date === 'string' ? new Date(date) : date, DATE_FORMAT);
}

export function toIsoDateFormat(dateString: string) {
  const date = toDateFromDatePickerFormat(dateString);
  if (date) {
    return format(date, ISO_DATE_FORMAT);
  }
}

// borrowed from:
// https://github.com/gpbl/react-day-picker/tree/master/packages/react-day-picker/src/contexts/SelectRange/utils
export function addToRange(
  day: Date,
  range?: DateRange
): DateRange | undefined {
  const { from, to } = range || {};
  if (!from) {
    return { from: day, to: undefined };
  }
  if (!to && isSameDay(from, day)) {
    return { from: from, to: day };
  }
  if (!to && isBefore(day, from)) {
    return { from: day, to: from };
  }
  if (!to) {
    return { from, to: day };
  }
  if (isSameDay(to, day) && isSameDay(from, day)) {
    return undefined;
  }
  if (isSameDay(to, day)) {
    return { from: to, to: undefined };
  }
  if (isSameDay(from, day)) {
    return undefined;
  }
  if (isAfter(from, day)) {
    return { from: day, to };
  }
  return { from, to: day };
}
